import { FormattedMessage, useIntl } from 'react-intl';

import { AutoComplete } from '@xing-com/auto-complete';
import { Headline } from '@xing-com/typography';

import type { YourTopicsEditViewObject } from '../../types';
import { getYourTopicsCharacterCounterString } from '../../utils';

import * as Styled from './your-topics-edit-view.styles';

export const YourTopicsEditView: React.FC<YourTopicsEditViewObject> = ({
  topics,
  suggestions,
  handleChange,
  resetSuggestions,
}) => {
  const intl = useIntl();

  return (
    <>
      <Headline size="xxlarge" noMargin>
        <FormattedMessage id="EP_YOUR_TOPICS_EDIT_VIEW_TITLE" />
      </Headline>
      <Styled.BodyCopy>
        <FormattedMessage id="EP_YOUR_TOPICS_EDIT_VIEW_COPY" />
      </Styled.BodyCopy>

      <Styled.FormFieldContainer>
        {topics.map((topic, index) => {
          return (
            <li key={index}>
              <AutoComplete
                key={index}
                label={intl.formatMessage({
                  id: 'EP_YOUR_TOPICS_EDIT_VIEW_LABEL',
                })}
                value={topic.name}
                suggestions={suggestions}
                onSelect={(suggestion) => {
                  handleChange(suggestion.name, index);
                }}
                onChange={(value): void => handleChange(value, index)}
                onBlur={() => resetSuggestions()}
                suggestionToString={(item) => (item ? item.name : '')}
                characterCounter={
                  <Styled.CharacterCounter>
                    {getYourTopicsCharacterCounterString(topic.name.length)}
                  </Styled.CharacterCounter>
                }
              />
            </li>
          );
        })}
      </Styled.FormFieldContainer>
    </>
  );
};
